<template>
    <div class="connections">
      <h1 class="connections__title page-title">Connections</h1>
  
      <el-tabs
        v-model="activeTab"
        class="connections__tabs"
        @tab-click="handleChangeTab"
      >
        <el-tab-pane label="Active" name="active" lazy>
          <connections type="active"/>
        </el-tab-pane>
        <el-tab-pane label="Requests sent" name="sent" lazy>
          <connections type="sent"/>
        </el-tab-pane>
        <el-tab-pane label="Requests received" name="received" lazy>
          <connections type="received"/>
        </el-tab-pane>
      </el-tabs>
    </div>
  </template>
  
  <script>
  import Connections from './Connections.vue';

  export default {
    name: 'ConnectionsPage',
    components: {
      Connections,
    },
    computed: {
      activeTab: {
        get() {
          return this.$route.query.tab || 'active';
        },
        set(value) {
          this.$router.push({
            query: {
              tab: value,
            },
          });
        },
      },
    },

    methods: {
      handleChangeTab({ name }) {
        const { activeTab } = this;
  
        if (name !== activeTab) {
          this.$router.push({
            route: 'UserProfile',
            query: {
              tab: name,
            },
          });
        }
      },
    },
  };
  </script>
  
  <style lang="scss">
  @import '~@/styles/shared/_globals.scss';
  
  .connections {
    &__title {
      margin: 0;
      margin-bottom: var(--global-dimension-size-250);
  
      font-weight: 500;
      font-size: var(--font-size-800);
      line-height: 1.6;
    }
  
    &__tabs {
      .el-tabs__item {
        font-size: var(--font-size-300);
        line-height: 1.6;
      }
      .el-tabs__header {
        margin-bottom: var(--global-dimension-size-350);
      }
    }
  }
  </style>
  